// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0af1fc90","186":"9b6631a3","225":"49cf2eda","344":"dc70260e","372":"628361c0","377":"3f57eb46","443":"ef99fa5b","573":"767a819a","738":"ae91c0c7","841":"f7e32541","856":"1b382ff2","909":"2e13088c"}[chunkId] + ".chunk.js";
};